import type { ElementType } from "react";
import styles from "./FeaturedIcon.module.css";
import iconColors from "./IconColors.module.css";
import { type IconColor } from "./IconColors";
// @ts-expect-error pure js
import { classnames } from "../../utils";

type FeaturedIconSize = "xs" | "sm" | "md" | "lg";
type FeaturedIconShape = "circle" | "square";
/** "soft" : fond teinté, icône colorée. "solid" : fond plein, icône blanche. */
type FeaturedIconVariant = "soft" | "solid";

const ICON_SIZE: Record<FeaturedIconSize, number> = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 28,
};

interface FeaturedIconProps {
  icon: ElementType;
  size?: FeaturedIconSize;
  shape?: FeaturedIconShape;
  color?: IconColor;
  variant?: FeaturedIconVariant;
  className?: string;
}

export default function FeaturedIcon({
  icon: Icon,
  size = "md",
  shape = "circle",
  color = "primary",
  variant = "soft",
  className,
}: FeaturedIconProps) {
  return (
    <div
      className={classnames(
        styles.tile,
        styles[`shape-${shape}`],
        styles[`size-${size}`],
        variant === "solid" && iconColors.solid,
        iconColors[color],
        className,
      )}
    >
      <Icon size={ICON_SIZE[size]} stroke={1.5} />
    </div>
  );
}
